import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import gameAPI from "../../api/admin/gameApi";
import { formatDateOnly } from "../../helper/Helper";

function GameList() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const stateId = localStorage.getItem("stateId");
    const constituencyId = localStorage.getItem("constituencyId");

    if (stateId && constituencyId) {
      fetchData(stateId, constituencyId);
    }
  }, []);

  const fetchData = async (stateId, constituencyId) => {
    const payload = {
      state: stateId,
      constituency: constituencyId,
    };

    const res = await gameAPI.getList(payload);
    if (res.code === 200) {
      setEvents(res.data);
    } else {
      setEvents([]);
    }
  };

  const redirectwithsession = (id) => {
    sessionStorage.setItem('selectedGameId', id);
    window.location.href = "/login";
  }

  return (
    <div className="main-wrapper">
      <div className="container overflow-hidden p-3 acc-vh">
        <h1 className="game-page-title">
          <i className="fas fa-trophy"></i> All Game List of Your Constituency
        </h1>

        <div className="row g-4">
          {events.map((item, key) => (
            <div className="col-md-4">
              <div className="card event-card" key={key}>
                <div className="card-header-custom">
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 className="game-title">{item.title}</h3>
                    {/* <span className="sport-badge">
                      <i className="fas fa-baseball-ball" /> Cricket
                    </span> */}
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <div className="date-label">Start Date</div>
                      <div className="date-value">
                        <i className="fas fa-calendar-alt" />{" "}
                        {formatDateOnly(item.start)}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="date-label">End Date</div>
                      <div className="date-value">
                        <i className="fas fa-calendar-check" />{" "}
                        {formatDateOnly(item.end)}
                      </div>
                    </div>
                  </div>
                  <div className="venue-info">
                    <i className="fas fa-map-marker-alt" />
                    <strong>Venue:</strong> {item.venue}
                  </div>

                  <div className="venue-info">
                    <strong>Sports:</strong> {item?.sports?.map(s => s.sportId?.name).join(", ")}
                  </div>

                  

                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: item?.description,
                    }}
                  />

                  <Link onClick={(e) => redirectwithsession(item?.id)} className="btn btn-primary participate-btn">
                    <i className="fas fa-play-circle" /> Participate Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GameList;
